/** biome-ignore-all lint/style/useNamingConvention: legacy */
export const DELETE_USER_TEACHING_UNIT_ERRORS = {
  USER_ROLE_NOT_FOUND: 'USER_ROLE_NOT_FOUND',
} as const;

export const ADD_USER_TEACHING_UNIT_ERRORS = {
  USER_ROLE_DUPLICATE: 'USER_ROLE_DUPLICATE',
  USER_ROLE_NOT_MATCHING: 'USER_ROLE_NOT_MATCHING',
} as const;

export const TEACHING_UNIT_LESSON_ERRORS = {
  LESSON_NOT_IN_TEACHING_UNIT: 'LESSON_NOT_IN_TEACHING_UNIT',
  ASSIGNMENT_NOT_IN_LESSON: 'ASSIGNMENT_NOT_IN_LESSON',
  TEACHING_UNIT_LESSON_IN_CLASSES: 'TEACHING_UNIT_LESSON_IN_CLASSES',
  TEACHING_UNIT_LESSON_ORIGIN_NOT_ALLOWED: 'TEACHING_UNIT_LESSON_ORIGIN_NOT_ALLOWED',
} as const;

export const COURSE_ERRORS = {
  STUDENT_NOT_IN_CLASS: 'STUDENT_NOT_IN_CLASS',
  LESSON_NOT_IN_CLASS: 'LESSON_NOT_IN_CLASS',
  WRONG_DIPLOMA_TYPE: 'WRONG_DIPLOMA_TYPE',
  LESSON_IN_CLASS: 'LESSON_IN_CLASS',
  TEACHING_UNIT_IN_CLASS: 'TEACHING_UNIT_IN_CLASS',
  COURSE_NOT_EMPTY: 'COURSE_NOT_EMPTY',
  CLASS_NOT_EMPTY: 'CLASS_NOT_EMPTY',
} as const;

export const COURSE_FORM_ERRORS = {
  DUPLICATE_CODE: 'DUPLICATE_CODE',
} as const;

export const TEACHING_UNIT_FORM_ERRORS = {
  DUPLICATE_CODE: 'DUPLICATE_CODE',
  DUPLICATE_LESSON: 'DUPLICATE_LESSON',
} as const;

export const CLASS_FORM_ERRORS = {
  DUPLICATE_CODE: 'DUPLICATE_CODE',
  DUPLICATE_E_COMMERCE: 'DUPLICATE_E_COMMERCE',
  UPDATE_FORBIDDEN: 'UPDATE_FORBIDDEN',
  LESSON_NOT_FOUND: 'LESSON_NOT_FOUND',
  LESSON_V_MAJOR_ERROR: 'LESSON_V_MAJOR_ERROR',
  ASSIGNMENTS_WRONG_AFFECTATION: 'ASSIGNMENTS_WRONG_AFFECTATION',
  EXAM_TEACHING_UNIT_NOT_IN_CLASS: 'EXAM_TEACHING_UNIT_NOT_IN_CLASS',
  TEST_CLASS_SALES_CHANNEL: 'TEST_CLASS_SALES_CHANNEL',
} as const;
